export const userData = [
    {
      name: "Jan",
      "Active User": 4000,
    },
    {
      name: "Feb",
      "Active User": 3000,
    },
    {
      name: "Mar",
      "Active User": 5000,
    },
    {
      name: "Apr",
      "Active User": 4000,
    },
    {
      name: "May",
      "Active User": 3000,
    },
    {
      name: "Jun",
      "Active User": 2000,
    },
    {
      name: "Jul",
      "Active User": 4000,
    },
    {
      name: "Agu",
      "Active User": 3000,
    },
    {
      name: "Sep",
      "Active User": 4000,
    },
    {
      name: "Oct",
      "Active User": 1000,
    },
    {
      name: "Nov",
      "Active User": 4000,
    },
    {
      name: "Dec",
      "Active User": 3000,
    },
  ];

  export const productData = [
    {
      name: "Jan",
      "Sales": 4000,
    },
    {
      name: "Feb",
      "Sales": 3000,
    },
    {
      name: "Mar",
      "Sales": 5000,
    },
  ];

  export const userRows = [
    // {
    //   id: 1,
    //   username: "Federico Kereki",
    //   avatar:
    //     "https://images.gr-assets.com/authors/1561336084p8/4123863.jpg",
    //   email: "federico@gmail.com",
    //   status: "active",
    //   transaction: "$950.00",
    // },
    // {
    //   id: 2,
    //   username: "Chinda Great",
    //   avatar:
    //     "https://scontent.flos2-2.fna.fbcdn.net/v/t39.30808-1/259036910_883607182369488_1079774333893976731_n.jpg?stp=dst-jpg_p200x200&_nc_cat=100&ccb=1-6&_nc_sid=7206a8&_nc_eui2=AeEL7K5HwIqXc3G2Fzog2UNraU-O-8JthrdpT477wm2Gt2AxHybrvfbbAiU8mMemHlKQ-zolQHb_lGx_jQ7osU2F&_nc_ohc=tnQ5HfCE_MIAX8tNOxL&_nc_ht=scontent.flos2-2.fna&oh=00_AT_xpHoht84Wbi1hwEySLhnoPtx7W9rCJVpGIN1sHZ2vFQ&oe=62851BD4",
    //   email: "chinda@gmail.com",
    //   status: "active",
    //   transaction: "$320.00",
    // },
    // {
    //   id: 3,
    //   username: "Ejiro ThankGod",
    //   avatar:
    //     "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    //   email: "ejiro@gmail.com",
    //   status: "active",
    //   transaction: "$600.00",
    // },
    // {
    //   id: 4,
    //   username: "Okoro Isaac",
    //   avatar:
    //     "https://media-exp1.licdn.com/dms/image/C4E03AQEhykPCKBTzRA/profile-displayphoto-shrink_800_800/0/1634862775537?e=1657756800&v=beta&t=P1dVhgLSGXr0rG0h2e0lsFLk4u5Pt-y5hdkT6t7u5PA",
    //   email: "isaac@gmail.com",
    //   status: "active",
    //   transaction: "$280.00",
    // },
    // {
    //   id: 5,
    //   username: "Samson Bolanle",
    //   avatar:
    //     "https://scontent.flos2-2.fna.fbcdn.net/v/t39.30808-6/266791365_307745627924597_3382790129827067064_n.jpg?_nc_cat=106&ccb=1-6&_nc_sid=09cbfe&_nc_eui2=AeFX8poq1Xz4KswGSx6dMVju1dchlB15X3DV1yGUHXlfcFGV4gcaeu4IL_eTpL8SoX1LmF8pPo5ZVWPVqpq6UuKr&_nc_ohc=ByU_UL0pbw0AX_sL3Zo&tn=B1kogRqk3VZP9qU-&_nc_zt=23&_nc_ht=scontent.flos2-2.fna&oh=00_AT_h-dxpWnhApoz75nqM_LkAIpZz17morNxM45AeZ0mSaA&oe=6285CE61",
    //   email: "bolanle@gmail.com",
    //   status: "active",
    //   transaction: "$120.00",
    // },
    // {
    //   id: 6,
    //   username: "Ugochi Success",
    //   avatar:
    //     "https://scontent.flos2-2.fna.fbcdn.net/v/t1.6435-9/73475280_172018693854643_6638146679256121344_n.jpg?stp=c0.23.206.206a_dst-jpg_p206x206&_nc_cat=106&ccb=1-6&_nc_sid=da31f3&_nc_eui2=AeE1PrTK_sh2bKFrb3mvJyBQYNtW8g8j89Zg21byDyPz1oJknCH_JRD0r1MeAbeAovt42p43Vh_6sbgTFkOx8BIG&_nc_ohc=YkfcNFYK6J4AX-uZuxH&tn=B1kogRqk3VZP9qU-&_nc_ht=scontent.flos2-2.fna&oh=00_AT9hP8rFLKMZngcvl8APmYZEHEWXm67ASMMSjQFoeDG0Eg&oe=62A57E5E",
    //   email: "ugochi@gmail.com",
    //   status: "active",
    //   transaction: "$120.00",
    // },
    // {
    //   id: 7,
    //   username: "Thompson Tasha",
    //   avatar:
    //     "https://pps.whatsapp.net/v/t61.24694-24/269238626_541674360877610_4124753309886716414_n.jpg?ccb=11-4&oh=01_AVw8uViSkxWY_TmOHuIAkhE8aDAZhMN_snPBsMOx8QkfBQ&oe=6290620E",
    //   email: "tasha@gmail.com",
    //   status: "active",
    //   transaction: "$520.00",
    // },
    // {
    //   id: 8,
    //   username: "Saviour Blessing",
    //   avatar:
    //     "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    //   email: "blessing@gmail.com",
    //   status: "active",
    //   transaction: "$820.00",
    // },
    // {
    //   id: 9,
    //   username: "Banigo Kene",
    //   avatar:
    //     "https://scontent.flos2-2.fna.fbcdn.net/v/t1.6435-9/187203285_947132126048608_8773191570853311344_n.jpg?stp=c0.137.480.480a_dst-jpg_s526x395&_nc_cat=107&ccb=1-6&_nc_sid=09cbfe&_nc_eui2=AeGe943A9EvcKTkjN-KDU2_7I0KhbHrb2EsjQqFsetvYSx-IC1M3ghzOOR_Q2Dv73uZ2JF1MiO3mLise4r4M02hK&_nc_ohc=lIJWTua5--MAX_d7Kfe&_nc_ht=scontent.flos2-2.fna&oh=00_AT8ieREmJZMRI9jSU61PxOm7uvVGGVUBDDVaZC0u8Zbx2g&oe=62A3DD06",
    //   email: "kene@gmail.com",
    //   status: "active",
    //   transaction: "$1000.00",
    // },
    // {
    //   id: 10,
    //   username: "Ikechi Fortune",
    //   avatar:
    //     "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    //   email: "fortune@gmail.com",
    //   status: "active",
    //   transaction: "$5700.00",
    // },
    {
      id: 11,
      firstName: "Abhay",
      // "lastName": "Pratap",
      profilePic: "https://i.pinimg.com/originals/36/fa/7b/36fa7b46c58c94ab0e5251ccd768d669.jpg",
      // "banner": "https://images.unsplash.com/photo-1502230831726-fe5549140034?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
      // "from": "Delhi",
      // "country": "India",
      // "college": "IIIT Delhi",
      // "specialization": "Web Development",
      // "description": "Best Detective in world. Also Known as L in death Note.Back Problems",
      // "experience": [
      //   "Worked as front-end developer",
      //   "Working in IBM design department."
      // ],
      // "Linkedin": "https://www.linkedin.com/in/abhay-pratap-singh-878457203/",
      Email: "abhaypratap.s20@iiits.in",
      status: "active",
      transaction: "$120.00",
      // "Password": "123"
    }
  ];

  export const productRows = [
    {
      id: 1,
      name: "Apple Airpods",
      img:
        "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      stock: 123,
      status: "active",
      price: "$120.00",
    },
    {
      id: 2,
      name: "Apple Watch Series 6",
      img:
        "https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product/G/I/174379_1610801608.jpg",
      stock: 123,
      status: "active",
      price: "$270.00",
    },
    {
      id: 3,
      name: "Apple Iphone 12",
      img:
        "https://www.reliancedigital.in/medias/Apple-12-Smartphones-491901537-i-1-1200Wx1200H-300Wx300H?context=bWFzdGVyfGltYWdlc3w0MjE5NnxpbWFnZS9qcGVnfGltYWdlcy9oZWEvaDExLzk0MDc3NDExMzI4MzAuanBnfDMyYzZkZjBlZmEyNTRkNGVjOGY4MTk1MWYwYzg2Yjg0YjdlNjI2N2QwNDgwMmM5OTUxZTcwYjZiYjA1YTc5Yzc",
      stock: 123,
      status: "active",
      price: "$720.00",
    },
    {
      id: 4,
      name: "Apple Airpods",
      img:
        "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      stock: 123,
      status: "active",
      price: "$120.00",
    },
    {
      id: 5,
      name: "Apple Iphone 11Pro",
      img:
        "https://www.gizmochina.com/wp-content/uploads/2019/09/Apple-iPhone-11-Pro-500x500.jpg",
      stock: 123,
      status: "active",
      price: "$600.00",
    },
    {
      id: 6,
      name: "Apple Watch Series 7",
      img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpAjx-8napBrslbug3yxYRh2yX0IBQI8hHxQ&usqp=CAU",
      stock: 123,
      status: "active",
      price: "$320.00",
    },
    {
      id: 7,
      name: "Apple Airpods",
      img:
        "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      stock: 123,
      status: "active",
      price: "$120.00",
    },
    {
      id: 8,
      name: "Apple Iphone 13",
      img:
        "https://m.media-amazon.com/images/I/71gm8v4uPBL._SL1500_.jpg",
      stock: 123,
      status: "active",
      price: "$950.00",
    },
    {
      id: 9,
      name: "Apple Airpods",
      img:
        "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      stock: 123,
      status: "active",
      price: "$120.00",
    },
    {
      id: 10,
      name: "Apple Watch Series 7",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpAjx-8napBrslbug3yxYRh2yX0IBQI8hHxQ&usqp=CAU",
      stock: 123,
      status: "active",
      price: "$320.00",
    },
  ];